import Beverage from "./Beverage";
import Cartridge from "./Cartridge";
import CBD from "./CBD";
import Dot from "./Dot";
import Edibles from "./Edibles";
import Extracts from "./Extracts";
import Flower from "./Flower";
import Merch from "./Merch";
import Miscellaneous from "./Miscellaneous";
import Pill from "./Pill";
import Plant from "./Plant";
import PrePacked from "./PrePacked";
import PreRoll from "./PreRoll";
import Radio from "./Radio";
import ThumbsUp from "./ThumbsUp";
import Tincture from "./Tincture";
import Topical from "./Topical";
export const customIcons = {
    Beverage,
    Cartridge,
    CBD,
    Dot,
    Edibles,
    Extracts,
    Flower,
    Merch,
    Miscellaneous,
    Pill,
    Plant,
    PrePacked,
    PreRoll,
    Radio,
    ThumbsUp,
    Tincture,
    Topical,
};
